import React, { createContext, useContext, useMemo } from 'react';

/**
 * Tracks dialog nesting depth so stacked dialogs can:
 * 1. Skip the backdrop after the first level (no cumulative darkening)
 * 2. Offset slightly to show depth (cascade effect)
 */
const DialogStackContext = createContext<number>(0);

export const useDialogDepth = () => useContext(DialogStackContext);

export const DialogStackProvider = ({ children }: { children: React.ReactNode }) => {
    const parentDepth = useContext(DialogStackContext);
    const depth = useMemo(() => parentDepth + 1, [parentDepth]);
    return (
        <DialogStackContext.Provider value={depth}>
            {children}
        </DialogStackContext.Provider>
    );
};
